import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { IoListOutline } from "react-icons/io5";
import { Link } from "react-router";
import styled from "styled-components";

import ListParameters from "./ListParameters.graphql";
import { TAXONOMY_BASE } from "../../../../../constants";

const StyledAssignedParameters = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    min-height: 0;
    flex: 1;
    overflow: hidden;

    .header-row {
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebecf0;

        h3 {
            color: #172b4d;
            font-size: 1rem;
            font-weight: 600;
            margin: 0;
        }

        .badge {
            background: #deebff;
            border-radius: 12px;
            color: #0747a6;
            font-size: 0.75rem;
            font-weight: 700;
            padding: 2px 8px;
        }
    }

    ul {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        gap: 6px;
        list-style: none;
        margin: 0;
        overflow-y: auto;
        padding: 0;

        li {
            a {
                align-items: center;
                border-radius: 6px;
                color: #172b4d;
                display: flex;
                font-size: 0.9rem;
                gap: 8px;
                padding: 8px 12px;
                text-decoration: none;
                transition: background 0.15s;

                &:hover {
                    background: #f4f5f7;
                    color: #0052cc;
                }

                svg {
                    color: #6b778c;
                }
            }
        }
    }

    .empty {
        color: #6b778c;
        font-size: 0.85rem;
        font-style: italic;
        padding: 12px 0;
    }

    .errors {
        color: #bf2600;
        font-size: 0.85rem;
        padding: 12px 0;
    }
`;

export default function AssignedParameters(props) {
    const { id } = props;

    const listParameters = useQuery(gql(ListParameters));

    if (listParameters.loading) return "loading";
    if (listParameters.error) return <div className="errors">Error loading parameters.</div>;

    const assigned = listParameters.data.parameters.filter((parameter) => parameter.group?.id === id);

    return (
        <StyledAssignedParameters>
            <div className="header-row">
                <h3>Assigned Parameters</h3>
                <span className="badge">{ assigned.length }</span>
            </div>
            { assigned.length === 0 ? (
                <div className="empty">No parameters assigned to this group yet.</div>
            ) : (
                <ul>
                    { assigned.map((parameter) => (
                        <li key={ parameter.id }>
                            <Link to={ `${ TAXONOMY_BASE }/Parameters/${ parameter.id }` }>
                                <IoListOutline />
                                { parameter.name[0]?.text ?? parameter.id }
                            </Link>
                        </li>
                    )) }
                </ul>
            ) }
        </StyledAssignedParameters>
    );
}
